import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { authSlice } from './slices/authSlice';
import { featureFlagsSlice } from './slices/featureFlagsSlice';
import { uiSlice } from './slices/uiSlice';
import { apiSlice } from './api/apiSlice';
import userSlice from './slices/userSlice';
import { betSlice } from './slices/betSlice';
import { mediaSlice } from './slices/mediaSlice';
import { mfaApi } from './api/mfaApi';
import oneClickBetReducer from './slices/oneClickBetSlice';
export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    user: userSlice,
    featureFlags: featureFlagsSlice.reducer,
    ui: uiSlice.reducer,
    api: apiSlice.reducer,
    bet: betSlice.reducer,
    media: mediaSlice.reducer,
    mfa: mfaApi.reducer,
    oneClickBet: oneClickBetReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export action creators
export const { login, logout } = authSlice.actions;
export const {
  setLoading,
  setError,
  clearError,
  setNotification,
  clearNotification,
  // toggleEditStake,
  // setEditStake,
} = uiSlice.actions;
